import React, { useState, useEffect, useRef } from 'react';
import './ClientProfile.css'
import PortalHeader from '../clientNavbar/PortalHeader'
import ClientProfilePopUp from './ClientProfilePopUp';
import { useAuth } from '../../Auth';
import { Link, useNavigate } from 'react-router-dom';

// CSRF imports
import Cookies from 'universal-cookie';
const cookies = new Cookies();

// Toast import 
import { toast, ToastContainer } from 'react-toastify';

// Assets
import tempImage from '../../pages/HeaderFolder/img/FNNLogoWithBlackFont-06.png'

// Icons
import { BiHomeAlt, BiKey, BiSupport, BiShow, BiHide } from "react-icons/bi";
import { LuUserRound } from "react-icons/lu";
import { RiLogoutCircleLine, RiMapPinRangeFill } from "react-icons/ri";
import { BsLightningChargeFill } from "react-icons/bs";
import { MdContactSupport } from "react-icons/md";
import { FaDiamond, FaCheck, FaPlaneUp, FaMapLocationDot, FaCirclePlay, FaHouseFire } from "react-icons/fa6";
import { HiPencilSquare } from "react-icons/hi2";
import { IoIosPaper, IoMdApps } from "react-icons/io";
import { SiMinutemailer } from "react-icons/si";
import { TbApiApp } from "react-icons/tb";
import { LuUtilityPole } from "react-icons/lu";
import { PiVideoCameraFill } from "react-icons/pi";
import { ImFire } from "react-icons/im";
import { TiWeatherStormy } from "react-icons/ti";
import { FaQuestion } from "react-icons/fa";

export function AssociateIconWithApp(app: string, iconClass: string) {
    switch (app) {
        case "Esri Dashboard":
            return <p> <BsLightningChargeFill className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "Detector Map":
            return <p> <RiMapPinRangeFill className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "Installation Manual":
            return <p> <IoIosPaper className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "Tutorial Videos":
            return <p> <FaCirclePlay className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "ForeFlight":
            return <p> <FaPlaneUp className={iconClass} style={{ color: " #28aee1" }} /> <strong>ForeFlight Integration</strong></p>
        case "Email Dispatch":
            return <p> <SiMinutemailer className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "API Endpoint":
            return <p> <TbApiApp className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "FNN Contact":
            return <p> <BiSupport className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "GridOS ADMS":
            return <p> <LuUtilityPole className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "Intterra":
            return <p> <FaMapLocationDot className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "AlertWest":
            return <p> <PiVideoCameraFill className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "FireSpread Model":
            return <p> <ImFire className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "HRL Forecast":
            return <p> <TiWeatherStormy className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        // case "FAQ":
        //     return <p> <FaQuestion className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "fiResponse":
            return <p> <FaHouseFire className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        case "Advanced Product Suite":
            return <p> <IoMdApps className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>
        // default:
        //     return <p> <MdContactSupport className={iconClass} style={{ color: " #28aee1" }} /> <strong>{app}</strong></p>

    }
}

interface BasicOrgInfo {
    ORG_NAME: string;
    ORG_LOGO: string | null; // URL or null
}

// Interface for reading notes
interface UserProfile {
    id: number, // optional when creating
    username: string,
    email: string,
    first_name: string,
    last_name: any,
    organization?: number
}


const ClientProfile = () => {

    const { logout, username, first_name, last_name, email, organization, plan, organization_permissions } = useAuth();
    const [activeSection, setActiveSection] = useState("overview");

    const [isEditingUsername, setIsEditingUsername] = useState(false);
    const [isEditingEmail, setIsEditingEmail] = useState(false);
    const [isEditingFirstName, setIsEditingFirstName] = useState(false);
    const [isEditingLastName, setIsEditingLastName] = useState(false);

    const [usernameInput, setUsernameInput] = useState(username);
    const [emailInput, setEmailInput] = useState(email);
    const [firstNameInput, setFirstNameInput] = useState(first_name);
    const [lastNameInput, setLastNameInput] = useState(last_name);
    const [showMenu, setShowMenu] = useState(false);

    const [originalUsername, setOriginalUsername] = useState(username);
    const [originalEmail, setOriginalEmail] = useState(email);
    const [originalFirstName, setOriginalFirstName] = useState(first_name);
    const [originalLastName, setOriginalLastName] = useState(last_name);

    const usernameRef = useRef<HTMLInputElement>(null);
    const emailRef = useRef<HTMLInputElement>(null);
    const firstNameRef = useRef<HTMLInputElement>(null);
    const lastNameRef = useRef<HTMLInputElement>(null);

    // Password changes
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPasswordSuccessPopup, setShowPasswordSuccessPopup] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    // Fetching org logo
    const [orgsInfo, setOrgsInfo] = useState<BasicOrgInfo>();

    const fetchOrgsInfo = async () => {
        try {
            const response = await fetch(`/portal/api/org_view/`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'same-origin',
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: BasicOrgInfo[] = await response.json();
            if (data.length > 0) {
                setOrgsInfo(data[0]);
            }

        } catch (err) {
            if (err instanceof Error) {
                console.error(err.message);
            } else {
                console.error('An unknown error occurred');
            }
        }
    };

    useEffect(() => {
        fetchOrgsInfo();
    }, []);

    // User edit info
    const [theUser, setTheUser] = useState<UserProfile | null>(null);

    // Temporary password and user info fix
    // useEffect(() => {
    //     // Only reload if we haven't reloaded before during this visit/session
    //     if (!sessionStorage.getItem('clientProfileReloaded')) {
    //         sessionStorage.setItem('clientProfileReloaded', 'true');
    //         window.location.reload();
    //     } else {
    //         // Clear the flag so next time they come fresh again (optional)
    //         sessionStorage.removeItem('clientProfileReloaded');
    //     }
    // }, []);

    const [csrfToken, setCsrfToken] = useState<string | null>(null);


    const getCsrfToken = (): string | null => {
        const metaTag = document.querySelector('meta[name="csrf-token"]');
        return metaTag ? metaTag.getAttribute('content') : null; // Return null if the meta tag is not found
    };

    const fetchCsrfToken = async () => {
        const response = await fetch('/api/csrf-token/', {
            method: 'GET',
            credentials: 'same-origin', // include cookies in the request
        });

        if (response.ok) {
            const data = await response.json();
            return data.csrfToken; // Return the CSRF token
        } else {
            console.error('Failed to fetch CSRF token');
            return null;
        }
    };

    useEffect(() => {
        const getToken = async () => {
            const token = await fetchCsrfToken();
            if (token) {
                setCsrfToken(token);
            }
        };
        getToken();
    }, []);

    const fetchUser = async () => {
        try {
            const response = await fetch('/portal/api/user_profile/', {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'same-origin',
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data: UserProfile = await response.json();
            setTheUser(data);
            setUsernameInput(data.username || "");
            setEmailInput(data.email || "");
            setFirstNameInput(data.first_name || "");
            setLastNameInput(data.last_name || "");

            // ✅ Initialize original values properly
            setOriginalUsername(data.username || "");
            setOriginalEmail(data.email || "");
            setOriginalFirstName(data.first_name || "");
            setOriginalLastName(data.last_name || "");

            // console.log(data);

        } catch (err) {
            if (err instanceof Error) {
                console.error(err.message);
            } else {
                console.error('An unknown error occurred');
            }
        }
    };

    const updateUserProfile = async () => {

        if (
            usernameInput === originalUsername &&
            emailInput === originalEmail &&
            firstNameInput === originalFirstName &&
            lastNameInput === originalLastName
        ) return;

        try {
            if (!csrfToken) {
                console.error("No CSRF token available");
                return;
            }

            const response = await fetch('/portal/api/user_profile/', {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken || ''
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    username: usernameInput,
                    email: emailInput,
                    first_name: firstNameInput,
                    last_name: lastNameInput
                })
            });

            if (!response.ok) {
                throw new Error("Failed to update profile");
            }

            const updatedData: UserProfile = await response.json();
            setTheUser(updatedData);
            // console.log("User profile updated:", updatedData);

        } catch (err) {
            console.error("Error updating profile:", err);
        }
    };

    const updatePassword = async () => {
        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match", {
                autoClose: 4000,
                style: {
                    backgroundColor: '#2d2f31',
                    color: 'white',
                    fontSize: '16px',
                }
            });
            return;
        }

        try {
            if (!csrfToken) {
                console.error("No CSRF token available");
                return;
            }

            const response = await fetch("/portal/api/user_profile/", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken || ""
                },
                credentials: "same-origin",
                body: JSON.stringify({
                    username: usernameInput,
                    email: emailInput,
                    first_name: firstNameInput,
                    last_name: lastNameInput,
                    password: newPassword,
                    password2: confirmPassword
                })
            });

            if (!response.ok) {
                throw new Error("Failed to update password");
            }

            // ✅ Show success popup and log out
            setShowPasswordSuccessPopup(true);
            await logout();

        } catch (err) {
            console.error("Error updating password:", err);
            toast.error("Something went wrong while updating your password", {
                autoClose: 4000,
                style: {
                    backgroundColor: '#2d2f31',
                    color: 'white',
                    fontSize: '16px',
                }
            });
        }
    };

    useEffect(() => {
        fetchUser();
    },
        []); // Empty dependency array to run once on mount


    // Popup
    const [showPopup, setShowPopup] = useState(false);
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);


    // Getting the values from Auth
    useEffect(() => {
        setUsernameInput(username || "");
        setEmailInput(email || "");
        setFirstNameInput(first_name || "");
        setLastNameInput(last_name || "");
    }, [username, first_name, last_name, email]);

    // Accepting the Enter key as the submit as well
    const handleKeyDown = (
        e: React.KeyboardEvent<HTMLInputElement>,
        setEditing: React.Dispatch<React.SetStateAction<boolean>>
    ) => {
        if (e.key === 'Enter') {
            setEditing(false);
            updateUserProfile();
        }
    };

    // Handles the cases that the user clicks outside the input field to cancel de edits and keeps the initial form value
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (isEditingUsername && usernameRef.current && !usernameRef.current.contains(event.target as Node)) {
                setUsernameInput(originalUsername);
                setIsEditingUsername(false);
            }

            if (isEditingEmail && emailRef.current && !emailRef.current.contains(event.target as Node)) {
                setEmailInput(originalEmail);
                setIsEditingEmail(false);
            }

            if (isEditingFirstName && firstNameRef.current && !firstNameRef.current.contains(event.target as Node)) {
                setFirstNameInput(originalFirstName);
                setIsEditingFirstName(false);
            }

            if (isEditingLastName && lastNameRef.current && !lastNameRef.current.contains(event.target as Node)) {
                setLastNameInput(originalLastName);
                setIsEditingLastName(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isEditingUsername, isEditingEmail, isEditingFirstName, isEditingLastName]);

    // Function that will submit the PUT request on clicking on the checkmark
    const handleCheckClick = (
        field: 'username' | 'email' | 'firstName' | 'lastName'
    ) => {
        switch (field) {
            case 'username':
                setIsEditingUsername(false);
                break;
            case 'email':
                setIsEditingEmail(false);
                break;
            case 'firstName':
                setIsEditingFirstName(false);
                break;
            case 'lastName':
                setIsEditingLastName(false);
                break;
        }
        updateUserProfile();
    };

    // Log out functionality
    const navigate = useNavigate();

    const handleLogout = () => {
        setShowLogoutPopup(false);  // Hide the popup
        logout();                   // Call your existing logout logic (e.g., clear auth)
        navigate('/login');         // Redirect to login
    };

    return (
        <div className='profile-page-wrapper'>
            <PortalHeader />
            <ToastContainer />

            <div className='profile-page-left'>
                <div className='profile-image-wrapper'>
                    <img
                        src={orgsInfo?.ORG_LOGO ? orgsInfo.ORG_LOGO : tempImage}
                        alt='profile-company'
                    />
                </div>


                <h1 className='profile-name'>
                    <strong>{firstNameInput} {lastNameInput}</strong>
                </h1>

                {/* Dropdown Toggle Button (visible on small screens) */}
                <button className='menu-toggle' onClick={() => setShowMenu(prev => !prev)}>
                    ☰ My Account
                </button>

                {/* Profile Menu */}
                <ul className={`profile-menu ${showMenu ? 'show' : ''}`}>
                    <li className={activeSection === "overview" ? "active-menu-item" : ""} onClick={() => (setActiveSection("overview"), setShowMenu(false))}>
                        <BiHomeAlt className='profile-menu-icons' /> Account Overview
                    </li>
                    <li className={activeSection === "details" ? "active-menu-item" : ""} onClick={() => (setActiveSection("details"), setShowMenu(false))}>
                        <LuUserRound className='profile-menu-icons' /> Account Details
                    </li>
                    <li className={activeSection === "recovery" ? "active-menu-item" : ""} onClick={() => (setActiveSection("recovery"), setShowMenu(false))}>
                        <BiKey className='profile-menu-icons' /> Password Reset
                    </li>
                    <li onClick={() => setShowLogoutPopup(true)} >
                        <RiLogoutCircleLine className='profile-menu-icons' /> Log Out
                    </li>
                </ul>
            </div>


            {activeSection === "overview" && (
                <div className='profile-account-overview'>


                    <div className='profile-plan-info'>
                        <h1>Account Overview</h1>
                        {plan === "Pro" ? (
                            <FaDiamond className="profile-plan-icons" style={{ color: '#ff9a01' }} />
                        ) : plan === "Enterprise" ? (
                            <FaDiamond className="profile-plan-icons" style={{ color: '#ffd901' }} />
                        ) : (
                            <FaDiamond className="profile-plan-icons" />
                        )}

                        <h3>{plan} Plan</h3>
                    </div>

                    <div className='profile-plan-summary-wrap'>
                        <h2><strong> Plan Summary</strong></h2>
                        <div className='profile-plane-summary'>
                            {organization_permissions.map((permission: string) => (
                                <React.Fragment key={permission}>
                                    {AssociateIconWithApp(permission, 'profile-menu-icons')}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>


                    <div className='profile-plan-buttons'>
                        <div className='profile-plan-button'>
                            <h2><strong> Your Plan</strong></h2>
                            <button className='account-button' onClick={() => setShowPopup(true)}>
                                Manage Plan
                            </button>

                        </div>

                        <div className='profile-plan-button'>
                            <h2><strong> Questions?</strong></h2>
                            <Link to='/fnn_portal_representative'><button className='account-button'> Contact Us</button></Link>
                        </div>
                    </div>

                </div>
            )}

            {activeSection === "details" && (
                <div className='profile-account-information'>
                    <h1>Account Information</h1>

                    <div className='profile-account-information-input-wrapper'>

                        <div><strong>Username</strong></div>
                        {isEditingUsername ? (
                            <div className="editable-input-container">
                                <input
                                    className="account-information-input"
                                    type="text"
                                    value={usernameInput}
                                    ref={usernameRef}
                                    onChange={(e) => setUsernameInput(e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(e, setIsEditingUsername)}
                                    autoFocus
                                />

                                <div
                                    onMouseDown={(e) => e.stopPropagation()} // prevents the mousedown from bubbling to document
                                    onClick={() => handleCheckClick('username')}
                                >
                                    <FaCheck className='profile-menu-icons clickable-icon' />
                                </div>
                            </div>
                        ) : (
                            <p
                                className='editable-account-info'
                                onClick={() => {
                                    setOriginalUsername(usernameInput);
                                    setIsEditingUsername(true);
                                }}

                            >
                                {usernameInput} <HiPencilSquare className='profile-menu-icons clickable-icon' />
                            </p>
                        )}

                        <div><strong>Email Address</strong></div>
                        {isEditingEmail ? (
                            <div className="editable-input-container">
                                <input
                                    className="account-information-input"
                                    type="text"
                                    value={emailInput}
                                    ref={emailRef}
                                    onChange={(e) => setEmailInput(e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(e, setIsEditingEmail)}
                                    autoFocus
                                />
                                <div
                                    onMouseDown={(e) => e.stopPropagation()} // prevents the mousedown from bubbling to document
                                    onClick={() => handleCheckClick('email')}
                                >
                                    <FaCheck className='profile-menu-icons clickable-icon' />
                                </div>
                            </div>
                        ) : (
                            <p
                                className="editable-account-info"
                                onClick={() => {
                                    setOriginalEmail(emailInput);
                                    setIsEditingEmail(true);
                                }}
                            >
                                <span>{emailInput}</span>
                                <HiPencilSquare className="profile-menu-icons clickable-icon" />
                            </p>

                        )}

                        <div><strong>First Name</strong></div>
                        {isEditingFirstName ? (
                            <div className="editable-input-container">
                                <input
                                    className="account-information-input"
                                    type="text"
                                    value={firstNameInput}
                                    ref={firstNameRef}
                                    onChange={(e) => setFirstNameInput(e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(e, setIsEditingFirstName)}
                                    autoFocus
                                />
                                <div
                                    onMouseDown={(e) => e.stopPropagation()} // prevents the mousedown from bubbling to document
                                    onClick={() => handleCheckClick('firstName')}
                                >
                                    <FaCheck className='profile-menu-icons clickable-icon' />
                                </div>
                            </div>
                        ) : (
                            <p
                                className='editable-account-info'
                                onClick={() => {
                                    setOriginalFirstName(firstNameInput);
                                    setIsEditingFirstName(true);
                                }}
                            >
                                {firstNameInput} <HiPencilSquare className='profile-menu-icons clickable-icon' />
                            </p>
                        )}

                        <div><strong>Last Name</strong></div>
                        {isEditingLastName ? (
                            <div className="editable-input-container">
                                <input
                                    className="account-information-input"
                                    type="text"
                                    value={lastNameInput}
                                    ref={lastNameRef}
                                    onChange={(e) => setLastNameInput(e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(e, setIsEditingLastName)}
                                    autoFocus
                                />
                                <div
                                    onMouseDown={(e) => e.stopPropagation()} // prevents the mousedown from bubbling to document
                                    onClick={() => handleCheckClick('lastName')}
                                >
                                    <FaCheck className='profile-menu-icons clickable-icon' />
                                </div>
                            </div>
                        ) : (
                            <p
                                className='editable-account-info'
                                onClick={() => {
                                    setOriginalLastName(lastNameInput);
                                    setIsEditingLastName(true);
                                }}

                            >
                                {lastNameInput} <HiPencilSquare className='profile-menu-icons clickable-icon' />
                            </p>
                        )}


                        <div><strong>Organization</strong></div>
                        <p>{organization}</p>

                        {/* <label><strong>Account Access</strong></label>
                        <p>FNN Team</p> */}

                    </div>


                </div>
            )}

            {activeSection === "recovery" && (
                <div className='profile-account-information account-information-extension'>
                    <h1>Change Your Password</h1>

                    <div className='profile-account-information-input-wrapper'>
                        <p>Create a new password below to update your account.</p>

                        {/* 🔐 New Password */}
                        <div><strong>New Password</strong></div>
                        <div className="editable-input-container editable-input-extended" style={{ position: "relative" }}>
                            <input
                                className="account-information-input recovery-email"
                                type={showNewPassword ? "text" : "password"}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <div
                                onClick={() => setShowNewPassword(prev => !prev)}
                                className='eye-icon'
                            >
                                {showNewPassword ? <BiHide /> : <BiShow />}
                            </div>
                        </div>

                        {/* 🔐 Confirm Password */}
                        <div><strong>Re-enter Password</strong></div>
                        <div className="editable-input-container editable-input-extended" style={{ position: "relative" }}>
                            <input
                                className="account-information-input recovery-email"
                                type={showConfirmPassword ? "text" : "password"}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            <div
                                onClick={() => setShowConfirmPassword(prev => !prev)}
                                className='eye-icon'
                            >
                                {showConfirmPassword ? <BiHide /> : <BiShow />}
                            </div>
                        </div>

                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <button className='account-button recovery-button' onClick={updatePassword}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {showPasswordSuccessPopup && (
                <div className="logout-popup-overlay">
                    <div className="logout-popup-content">
                        <div className='password-wrapper'>
                            <h1><strong>Password Changed!</strong></h1>
                            <p>Your password was updated successfully. You must log in again to continue.</p>

                            <div className='account-logout-buttons'>
                                <div>
                                    <a
                                        href="/login"
                                        className="account-button options-button-addon2"
                                        onClick={() => {
                                            setShowPasswordSuccessPopup(false);
                                            logout(); // still call logout to clear client state
                                        }}
                                    >
                                        Go to Login
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}




            {showPopup && <ClientProfilePopUp onClose={() => setShowPopup(false)} />}

            {showLogoutPopup &&
                <div className="logout-popup-overlay">
                    <div className="logout-popup-content">
                        <div className='logout-wrapper'>
                            <h1><strong>Confirm Log Out</strong> </h1>
                            <p>Logging out will end your current session. Do you wish to continue?</p>

                            <div className='account-logout-buttons'>
                                <div>
                                    <button className='account-button options-button-addon' onClick={() => (setShowLogoutPopup(false), setShowMenu(false))}>
                                        Cancel
                                    </button>
                                </div>
                                <div>
                                    <button className='account-button options-button-addon' onClick={handleLogout}>
                                        Log out
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            }




        </div>
    )
}

export default ClientProfile